import React, { useContext, useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { getColors } from "../../../themes/theme";
import { ThemeContext } from "../../../context/ThemeContext";
import { CustomProtocolItem } from "./CustomProtocolItem";

export const ProtocolSelection = ({
  customProtocolData,
  ebprotocolData,
  onSelectionChange,
  checkedID,
  disabled,
}) => {
  const { darkMode } = useContext(ThemeContext);
  const [selectedProtocol, setSelectedProtocol] = useState(null); // Track the selected protocol (ID and type)

  useEffect(() => {
    if (checkedID !== null) {
      const selected = {
        id: checkedID[0]?.protocolid,
        type: checkedID[0]?.type,
      }; // Create the selected protocol object
      setSelectedProtocol(selected); // Update the selected protocol state
    }
  }, [checkedID]); // Only run when checkedIDs changes

  const handleProtocolItemClick = (protocolId, type) => {
    const selected = { id: protocolId, type }; // Create the selected protocol object
    setSelectedProtocol(selected); // Update the selected protocol state
    onSelectionChange(selected); // Notify the parent component about the selection
  };

  return (
    <Box display={!disabled ? "block" : "none"} sx={{ mb: 8 }}>
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: "28px",
          fontWeight: 500,
          color: darkMode
            ? getColors.drawerTextDark
            : getColors.thumbnailTextLight,
        }}
      >
        Exercises
      </Typography>
      <Box
        display="grid"
        gap={3}
        sx={{
          mt: 5,
          gridTemplateColumns: {
            xs: "repeat(1, minmax(0, 1fr))",
            sm: "repeat(2, minmax(0, 1fr))",
            md: "repeat(1, minmax(0, 1fr))",
            lg: "repeat(2, minmax(0, 1fr))",
            xl: "repeat(3, minmax(0, 1fr))",
          },
        }}
      >
        {customProtocolData?.map((customprotocol, index) => (
          <CustomProtocolItem
            key={index}
            {...customprotocol}
            type="custom"
            isChecked={
              selectedProtocol?.id === customprotocol.id &&
              selectedProtocol?.type === "custom"
            } // Check if this item is selected
            onCheck={() => handleProtocolItemClick(customprotocol.id, "custom")}
          />
        ))}
        {ebprotocolData?.map((ebprotocol, index) => (
          <CustomProtocolItem
            key={index}
            {...ebprotocol}
            type="ebp"
            isChecked={
              selectedProtocol?.id === ebprotocol.id &&
              selectedProtocol?.type === "ebp"
            } // Check if this item is selected
            onCheck={() => handleProtocolItemClick(ebprotocol.id, "ebp")} // Pass protocol ID and type
          />
        ))}
      </Box>
    </Box>
  );
};
